import type { ExternalDepartmentFragment } from "@/graphql";
import type { IMultiSelectItem, IOption } from "@/interfaces";

const toMultiSelectItem = (
  item: ExternalDepartmentFragment,
): IMultiSelectItem => {
  return {
    id: item.id,
    title: [item.institution.name, item.name]
      .filter((element) => {
        return element !== null && element !== undefined;
      })
      .join(" - "),
    icon: "fas fa-home",
    iconBackground: item.color || undefined,
  };
};

const toOption = (item: ExternalDepartmentFragment): IOption => {
  return {
    value: item.id,
    title: [item.institution.name, item.name]
      .filter((element) => {
        return element !== null && element !== undefined;
      })
      .join(" - "),
  };
};

export default {
  toMultiSelectItem,
  toOption,
};
